import { RegionalAirportConfig } from "@/components/RegionalLayout";
import { RegionalVuelosConfig } from "@/components/RegionalVuelos";

export const mpsmVuelosConfig: RegionalVuelosConfig = {
  airport: "rih",
  airportCode: "MPSM",
  basePath: "/mpsm/vuelos",
  backPath: "/mpsm",
};

export const mpsmConfig: RegionalAirportConfig = {
  code: "MPSM",
  name: {
    es: "Aeropuerto Internacional Scarlett Martínez",
    en: "Scarlett Martinez International Airport",
  },
  basePath: "/mpsm",
  navLinks: [
    {
      label: { es: "Inicio", en: "Home" },
      href: "/mpsm",
    },
    {
      label: { es: "Vuelos", en: "Flights" },
      href: "/mpsm/vuelos",
    },
    {
      label: { es: "Pasajeros", en: "Passengers" },
      href: "/mpsm/pasajeros",
    },
    {
      label: { es: "Aeropuertos", en: "Airports" },
      href: "/aeropuertos",
    },
    {
      label: { es: "Contacto", en: "Contact" },
      href: "/mpsm/mantenimiento",
    },
  ],
  contact: {
    phone: "+(507) 316-3777",
    email: "info@tocumenpanama.aero",
    address: {
      es: "Río Hato, Provincia de Coclé, Panamá",
      en: "Rio Hato, Coclé Province, Panama",
    },
  },
  socialLinks: {
    facebook: "https://facebook.com/tocumenairport",
    instagram: "https://instagram.com/tocumenairport",
    twitter: "https://twitter.com/tocumenairport",
  },
};
